import axios from 'axios'

var qs = require('qs');
var root=process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/list', qs.stringify(params))
}

export const getListallData = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/listall', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/remove',  qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/edit', qs.stringify(params))
}

export const getCategoryDetail = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/edit', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.categorycode) {//修改
    return axios.post(root+'/set/jxcgoodscategory/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/jxcgoodscategory/save',qs.stringify(params))
  }
}

//获取产品类型树
export const getjdTree =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/tree',qs.stringify(params))
}

//获取查询条件
export const getquery =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/findquery',qs.stringify(params))
}

//获取form属性
export const getform =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/findform',qs.stringify(params))
}

//获取form属性
export const getGoodsDetail =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/getGoodsDetail',qs.stringify(params))
}

export const removeGoodsRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/removeGoodsRight',qs.stringify(params))
}

export const listGoodsRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/listGoodsRight',qs.stringify(params))
}

export const batchsaveGoodsRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/batchsaveGoodsRight',qs.stringify(params))
}

export const batchsaveGoodsHandlerRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/batchsaveGoodsHandlerRight',qs.stringify(params))
}

export const listGoodsHandlerRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/listGoodsHandlerRight',qs.stringify(params))
}

export const removeGoodsHandlerRight =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/removeGoodsHandlerRight',qs.stringify(params))
}

export const updateHandlerRight=(params) => {
  return axios.post(root+'/set/jxcgoodscategory/updateHandlerRight',qs.stringify(params))
}


export const wholesearchmodel=(params) => {
  return axios.post(root+'/set/jxcgoodscategory/wholesearchmodel',qs.stringify(params))
}

export const wholesearchname=(params) => {
  return axios.post(root+'/set/jxcgoodscategory/wholesearchname',qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcgoodscategory.js